import { VideoEditor } from '../components/VideoEditor';

export default function VideoAnimePage() {
  return <VideoEditor style="anime" />;
}
